import { render, staticRenderFns } from "./UserManager.vue?vue&type=template&id=4095b39e&"
import script from "./UserManager.vue?vue&type=script&lang=ts&"
export * from "./UserManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports